import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import * as IconComponents from "../icons";
import React, { useContext } from "react";
import { InputWrapper } from "./InputWrapper";
import { ThemeProviderContext } from "../ThemeProvider";
export const TextInput = React.forwardRef((internalProps, ref) => {
    var _a;
    const props = Object.assign(Object.assign({}, internalProps), { size: (_a = internalProps.size) !== null && _a !== void 0 ? _a : "medium" });
    const theme = useContext(ThemeProviderContext);
    const handleChange = (event) => {
        var _a;
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, { event, value: event.target.value });
    };
    const PrefixIcon = props.prefixIcon
        ? IconComponents[`${props.prefixIcon}Icon`]
        : null;
    const iconClasses = [
        "absolute",
        props.isDisabled
            ? "fill-text-disabled dark:fill-text-disabled-darkmode"
            : "fill-text-subdued dark:fill-text-subdued-darkmode",
        "cursor-text",
        "pointer-events-none",
        props.size === "small" && "top-0.75",
        props.size === "medium" && "top-[9px]",
        props.size === "large" && "top-[11px]",
    ];
    const iconSize = props.size === "large" ? "md" : "sm";
    return (_jsx(InputWrapper, Object.assign({}, props, { render: ({ inputClasses, isReadonly, isDisabled }) => {
            let SuffixIcon = null;
            if (isReadonly || isDisabled) {
                SuffixIcon = IconComponents.LockIcon;
            }
            else if (props.suffixIcon) {
                SuffixIcon = IconComponents[`${props.suffixIcon}Icon`];
            }
            const allInputClasses = classNames(inputClasses, [
                props.prefixIcon && props.size === "large" && "!pl-4 pr-1",
                props.prefixIcon && props.size !== "large" && "!pl-3.5 pr-1",
                props.suffixIcon && props.size === "large" && "!pr-4 pl-1",
                props.suffixIcon && props.size !== "large" && "!pr-3.5 pl-1",
            ]);
            return (_jsxs("div", { className: "relative", children: [PrefixIcon &&
                        React.cloneElement(_jsx(PrefixIcon, { size: iconSize }), {
                            className: classNames(iconClasses, "left-1"),
                        }), _jsx("input", { ref: ref, type: "text", onChange: handleChange, value: props.value, className: allInputClasses, placeholder: props.placeholder, disabled: isDisabled, readOnly: isReadonly, name: props.name, id: props.id, [theme.testAttribute]: props.testId }), SuffixIcon &&
                        React.cloneElement(_jsx(SuffixIcon, { size: iconSize }), {
                            className: classNames(iconClasses, "right-1"),
                        })] }));
        } })));
});
//# sourceMappingURL=TextInput.js.map